
encoding = exports


    # TODO: look into purely regex ways of doing this. Rendering arbitrary html
    # in any context - even if it's not on the page - may pose a security risk.

encoding.htmlEncode = (str, allowedTags = [], sanitize = true) ->
    # encode html entities

    # Script and style tags are always removed. Pass allowedTags = ['*'] to
    # include all other html tags.

    if sanitize
        str = encoding.sanitize(str)

    str = encoding.limitTags(str, allowedTags)

    # str = String(str)
    #         .replace(/&/g, '&amp;')
    #         .replace(/"/g, '&quot;')
    #         .replace(/'/g, '&#39;')
    #         .replace(/</g, '&lt;')
    #         .replace(/>/g, '&gt;')

    str = $('<div/>').text(str).html()

    return str


encoding.htmlDecode = (str, allowedTags = [], sanitize = true) ->
    # decode html entities

    # Script and style tags are always removed. Pass allowedTags = ['*'] to
    # include all other html tags.

    # str = String(str)
    #         .replace(/&amp;/g, '&')
    #         .replace(/&quot;/g, '"')
    #         .replace(/&#39;/g, '\'')
    #         .replace(/&lt;/g, '<')
    #         .replace(/&gt;/g, '>')

    str = $('<div/>').html(str).text()

    if sanitize
        str = encoding.sanitize(str)

    str = encoding.limitTags(str, allowedTags)

    return str


encoding.limitTags = (str, allowedTags = []) ->
    # allow only specific html tags

    # Filtering with *:not() will allow us to preserve text nodes, rather than
    # trying to select only valid tags. (Seems silly, but you can't select text
    # nodes for some reason.)
    selStr = '*:not(' + allowedTags.join(',') + ')'
    dom = $('<div/>').html(str)
    dom.find(selStr).replaceWith () ->
        return $(this).text()
    str = dom.html()

    # String(str).replace(new RegExp('\<(/?[^\>]+)\>', 'ig'), '')

    return str


encoding.sanitize = (str) ->
    # remove all script and style tags

    dom = $('<div/>').html(str)
    dom.find('script,style').remove()
    str = dom.html()

    return str
